import React, {useState, useEffect} from 'react';
import useStateWithCallback from 'use-state-with-callback';

export const WishList = () => {  
    const [errorMessage, setErrorMessage] = useState([]);
    const [items, setItems] = useState([]);
    const [wishListLoading, setWishListLoading] = useState(false);

    const primaryButtonBackground = getComputedStyle(document.documentElement).getPropertyValue('--primary-button-background');
    const secondaryButtonBackground = getComputedStyle(document.documentElement).getPropertyValue('--header-border-color');

    const [selectedItems, setSelectedItems] = useStateWithCallback([], selectedItems => {
        if (wishListLoading) {
            return;
        }

        setBulkMoveToCart(selectedItems.length > 0);

        const chk = document.getElementById("checkboxWishListItemAction");

        if (chk == undefined || !chk) {
            return;
        }

        if (selectedItems.length == 0) {
            chk.indeterminate = false;
            chk.checked = false;
        }
        else if (selectedItems.length == items.length) {
            chk.indeterminate = false;
            chk.checked = true;
        }
        else if (selectedItems.length > 0 && selectedItems.length < items.length) {
            chk.indeterminate = true;
        }
      });

    const [bulkMoveToCart, setBulkMoveToCart] = useState(false);

    useEffect(() => {
        setErrorMessage(null);

        if (!customerId || customerId === 0) {
          return;
        }

        const getWishListItems = async () => {
            setWishListLoading(true);
            updateStatusOnLoading(true);

            const url = `${endpointLink}/getWishListItems/${customerId}`;

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'token': token
                    }
                });

                const data = await response.json();

                if (!data.result) {
                    setErrorMessage({ message: data.message, errorCode: data.errorCode });
                    console.log(data);
                }
                else {
                    const wishListItems = data.data;
                    const items = [];

                    for (let i = 0; i < wishListItems.length; i++) {
                        const item = wishListItems[i];
                        const handle = item.Handle;

                        const product = await getProduct(handle);
                        const productMinQty = getProductMinQty(product);
                        let productPackQty = getProductPackQty(product);

                        let qty = parseInt(item.Qty);
                        if (qty < productMinQty) {
                            qty = productMinQty;
                        }

                        qty = qty - (qty % productPackQty);
                        
                        if (productPackQty == 0) {
                            productPackQty = 1;
                        }

                        if (product) {
                            const variantId = parseInt(item.VariantID);
                            const found = product.variants.filter(item => item.id == variantId);
                            
                            if (found.length > 0) {
                                const itm = {
                                    id: parseInt(item.WishListItemID),
                                    customerId: item.CustomerID,
                                    productId: item.ProductID,
                                    handle: item.Handle,
                                    variantId: variantId,
                                    qty: qty,
                                    minQty: productMinQty,
                                    packQty: productPackQty,
                                    product: product,
                                    variant: found[0]
                                }

                                updateProductPrice(itm, variantId);

                                items.push(itm);
                            }
                            else {
                                removeWishListItem(item.WishListItemID);
                            }
                        }
                    }
                    
                    setItems(items);

                    if (items.length > 0) {
                        updateQtyInputs(items);
                        updateListItemsStatus(items);
                    }

                    updateStatusOnLoading(false);
                    setWishListLoading(false);
                }
            } catch (error) {
                setErrorMessage({ message: error, errorCode: errorCode.appApiError });
                console.log(error);

                setWishListLoading(false);
            }
        }

        const getProduct = async (handle) => {
            const url = `/products/${handle}.json`;

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                const data = await response.json();
                
                if (data) {
                    return data.product;
                }
                else {
                    return null;
                }
            } catch (error) {
                setErrorMessage({ message: error, errorCode: errorCode.shopifyApiError });
                console.log(error);
            }
        }

        const updateQtyInputs = (items) => {
            items.map(item => {
                console.log('item', item);
                const inputWishListItemQtyDesktop = document.getElementById(`inputWishListItemQtyDesktop-${item.id}`);

                if (inputWishListItemQtyDesktop) {
                    inputWishListItemQtyDesktop.value = item.qty;
                }

                const inputWishListItemQtyMobile = document.getElementById(`inputWishListItemQtyMobile-${item.id}`);

                if (inputWishListItemQtyMobile) {
                    inputWishListItemQtyMobile.value = item.qty;
                }
            })
        }

        const updateListItemsStatus = (items) => {
            items.map(item => {
                const id = item.id;
                const listItemStatus = getListItemStatus(item);

                if (!listItemStatus.enabled) {
                    const checkboxWishListItemAction = `checkboxWishListItemAction-${id}`;

                    document.getElementById(checkboxWishListItemAction).disabled = true;
                }
                
                const moveWishListItemToCartAction = `moveWishListItemToCartAction-${id}`;
                document.getElementById(moveWishListItemToCartAction).style.visibility = listItemStatus.enabled ? 'visible' : 'hidden';
            })
        }

        getWishListItems();
    }, []);

    function getProductMinQty(product) {
        const productTags = product.tags.split(',').map(item => item.trim());
        const minimumQtyTag = productTags.find(item => item.startsWith('EP:MinimumQty|'));

        if (minimumQtyTag) {
            const qty = getAmountFromTag(minimumQtyTag, '|');

            if (qty != null) {
                return parseInt(qty);
            }
        }
        
        return 0;
    }

    function getProductPackQty(product) {
        const productTags = product.tags.split(',').map(item => item.trim());
        const packQtyTag = productTags.find(item => item.startsWith('EP:PackQty|'));

        if (packQtyTag) {
            const qty = getAmountFromTag(packQtyTag, '|');

            if (qty != null) {
                return parseInt(qty);
            }
        }
        
        return 0;
    }

    function updateProductPrice(itm, variantId) {
        let tag = '';
        let student = false;

        if(customerTags.includes("UserType:NationalPartner")) {
            tag = 'PRICE:NP|';
        }
        else if (customerTags.includes("UserType:STPStudent")) {
            tag = 'PRICE:STP|';
            student = true;
        }
        else if (customerTags.includes("UserType:STPStaff")) {
            tag = 'PRICE:STP|';
        }
        
        if (tag == '' || itm.product.tags.length == 0) {
            return;
        }
        
        const productTags = itm.product.tags.split(',').map(item => item.trim());

        if (student) {
            const variant = itm.product.variants.find(item => item.id == variantId);

            if (variant) {
                const purchasedTag = `purchased_${variant.sku}`;
                const purchased = customerTags.includes(purchasedTag);

                if (purchased) {
                    return;
                }
            }

            const price = itm.variant.price;

            let specialPrice = null;
            const specialPriceTag = productTags.find(item => item.startsWith(tag));

            if (specialPriceTag) {
                specialPrice = getAmountFromTag(specialPriceTag, '|');
            }

            let studentCanBuy = false;

            if (price != undefined && price != null && specialPrice != null) {
                studentCanBuy = productTags.includes('EP:StudentCanBuy|Y');
            }

            if (studentCanBuy) {
                const amountSpentTag = customerTags.find(item => item.startsWith('amount_spent'));
                const discountLimitTag = customerTags.find(item => item.startsWith('discount_limit'));

                if (amountSpentTag && discountLimitTag) {
                    const amountSpent = getAmountFromTag(amountSpentTag, ':');
                    const discountLimit = getAmountFromTag(discountLimitTag, ':');

                    if (parseFloat(amountSpent) >= parseFloat(discountLimit)) {
                        return;
                    }
                }

                itm.product.specialPrice = specialPrice;
            }
        }
        else {
            let priceTag = productTags.filter(t => t.includes(tag));

            if (priceTag.length > 0) {
                const price = priceTag[0].split('|');

                if (price[1]) {
                    itm.product.specialPrice = parseFloat(price[1]).toFixed(2);
                }
            }
        }
    }

    function getModuleErrorHtml(msg) {
        const arr = msg.toString().split("&lt;br /&gt;");
        return arr.map((item, index) => <div key={index.toString()}>{item}</div>);
    }

    return (
        <main id="main" role="main">
            {customerId
            ?
            !errorMessage
                ?
                items != undefined && items != null && items.length > 0 
                    ?
                    <>
                    <div id="shopify-section-wish-list-template" className="shopify-section">
                        <div className="container">
                            <header className="page__header page__header--stack">
                                <h1 className="page__title heading h1">{titleLabel}</h1>
                            </header>
                        </div>
                    </div>

                    <div className="cart-wrapper" style={{minHeight: '376px'}}>
                        <div className="cart-wrapper__inner">
                            <div className="container container--flush">
                                <div className="card">
                                    <div className="table-wrapper">
                                        <div className="hidden-phone" style={{ paddingLeft: 5, paddingTop: 5, paddingRight: 0, paddingBottom: 0 }}>
                                            <button type="button" id="bulkMoveToCart" className="product-form__add-button button button--primary" style={{ background: bulkMoveToCart ? primaryButtonBackground : secondaryButtonBackground }} disabled={!bulkMoveToCart} onClick={() => moveWishListItemsToCart()}>
                                                {moveToCartLabel}
                                            </button>
                                        </div>
                                        <table className="line-item-table table table--loose">
                                            <thead className="hidden-phone">
                                                <tr>
                                                    <th style={{ paddingLeft: 0, paddingRight: 0, width: 5 }}>
                                                        <div className="hidden-phone" style={{ textAlign: "center", paddingLeft: 0, paddingRight: 0 }}>
                                                            <input type="checkbox" id="checkboxWishListItemAction" onChange={e => setBulkActions(e.target.checked)} />
                                                        </div>
                                                    </th>
                                                    <th>{productLabel}</th>
                                                    <th className="table__cell--center">{quantityLabel}</th>
                                                    <th className="table__cell--right">{totalLabel}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {items.map((item) => (
                                                getRow(item)
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    :
                    <div className="container">
                        <div className="empty-state">
                            <div className="empty-state__icon">
                                <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                                    <g transform="translate(0 2)" strokeWidth="4" stroke="#1a1a1a" fill="none" fillRule="evenodd">
                                        <circle strokeLinecap="square" cx="34" cy="60" r="6"></circle>
                                        <circle strokeLinecap="square" cx="67" cy="60" r="6"></circle>
                                        <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                                    </g>
                                </svg>
                            </div>
                            
                            <p id="wishListEmptyPar" className="empty-state__heading heading h1">
                                {/* {loadingLabel} */}
                            </p>
                            <div className="empty-state__button-container">
                                <a href="/collections/all" className="empty-state__button button button--primary">
                                    {shopProducts}
                                </a>
                            </div>
                        </div>
                    </div>
                :
                <div className="container">
                    <div className="empty-state">
                        <div className="empty-state__icon">
                            <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                                <g transform="translate(0 2)" strokeWidth="4" stroke="#1a1a1a" fill="none" fillRule="evenodd">
                                    <circle strokeLinecap="square" cx="34" cy="60" r="6"></circle>
                                    <circle strokeLinecap="square" cx="67" cy="60" r="6"></circle>
                                    <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                                </g>
                            </svg>
                        </div>
                        
                        <div className="empty-state__heading heading h1">
                            {getModuleErrorHtml(errorLoadingWishList)}
                        </div>
                        <div>
                            {getErrorBlock()}
                        </div>
                    </div>
                </div>
            :
            <div className="container">
                <div className="empty-state">
                    <div className="empty-state__icon">
                        <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                            <g transform="translate(0 2)" strokeWidth="4" stroke="#1a1a1a" fill="none" fillRule="evenodd">
                                <circle strokeLinecap="square" cx="34" cy="60" r="6"></circle>
                                <circle strokeLinecap="square" cx="67" cy="60" r="6"></circle>
                                <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                            </g>
                        </svg>
                    </div>
                    
                    <p className="empty-state__heading heading h1">
                        {loginToSeeWishList}
                    </p>
                    <div className="empty-state__button-container">
                        <a href="/collections/all" className="empty-state__button button button--primary">
                            {shopProducts}
                        </a>
                    </div>
                </div>
            </div>
            }
        </main>
    )
    
    function updateStatusOnLoading(loading) {
        const wishListEmptyPar = document.getElementById(`wishListEmptyPar`);

        if (wishListEmptyPar == null) {
            return;
        }

        if (loading) {
            wishListEmptyPar.innerHTML = loadingLabel;
        }
        else {
            wishListEmptyPar.innerHTML = wishListEmpty;
        }
    }

    function getRow(item) {
        if (item == undefined || !item || item.variant == undefined || !item.variant) {
            return '';
        }

        const id = item.id;
        const vendor = item.vendor;
        const product = item.product;
        const variant = item.variant;
        const sku = variant.sku;
        const variantId = variantId;
        const handle = item.handle;
        const title = product.title;
        const price = getPrice(item);
        const qty = item.qty;
        const minQty = item.minQty;
        const packQty = item.packQty;
        const total = parseFloat(price * qty).toFixed(2);
        const listItemStatus = getListItemStatus(item);

        const hasOnlyDefaultVariant = variant.title == "Default Title";
        let productImage = '';

        if (hasOnlyDefaultVariant) {
            if (product.image) {
                productImage = product.image.src;
            }
        }
        else {
            if (variant.image_id == null) {
                productImage = product.image.src;
            }
            else {
                const productImages = product.images;
                const imageId = variant.image_id;
                
                const variantImage = productImages.find(itm => itm.id == imageId);
                
                if (variantImage) {
                productImage = variantImage.src;
                }
            }
        }

        let options = [];
        if (!hasOnlyDefaultVariant) {
            options = product.options.map((itm) => {
                return {
                    id: itm.id,
                    name: itm.name,
                    value: variant[`option${itm.position}`]
                }
            });
        }

        const collectionUrl = `/collections/vendors?q=${vendor}`;
        let productUrl = `/products/${handle}`;
        if (variantId != undefined && variantId) {
            productUrl += `?variant=${variantId}`;
        }

        const row = `wishListItemRow-${id}`;
        const checkboxWishListItemAction = `checkboxWishListItemAction-${id}`;
        const inputQtyDesktop = `inputWishListItemQtyDesktop-${id}`;
        const inputQtyMobile = `inputWishListItemQtyMobile-${id}`;
        const wishListItemPrice = `wishListItemPrice-${id}`;
        const wishListItemTotal = `wishListItemTotal-${id}`;
        const wishListItemStatus = `wishListItemStatus-${id}`;
        const moveWishListItemToCartAction = `moveWishListItemToCartAction-${id}`;

        return (
            <tr key={id.toString()} id={row} className="line-item line-item--stack">
            <td>
                <div className="hidden-phone" style={{ textAlign: "center", paddingLeft: 0, paddingRight: 0 }}>
                    <input type="checkbox" id={checkboxWishListItemAction} onChange={e => setBulkActionControls(id, e.target.checked)} />
                </div>
            </td>

            <td className="line-item__product-info" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div className="line-item__product-info-wrapper">
                    <div className="line-item__image-wrapper">
                        <div className="aspect-ratio" style={{paddingBottom: '100.0%'}}>
                            <img src={productImage} alt={title} />
                        </div>
                    </div>
                    <div className="line-item__meta">
                        <a className="line-item__vendor link" href={collectionUrl}>{vendor}</a>
                        <a className="line-item__sku link" href={collectionUrl}>{sku}</a>

                        <a href={productUrl} className="line-item__title link text--strong">{title}</a>
                        
                        {options.length > 0
                        ? 
                            <div className="product-details">
                                {options.map((option) => (
                                    <div className="product-details__item product-details__item--variant-option" key={option.id.toString()}>
                                        {option.name}: {option.value}
                                    </div>
                                ))}
                            </div>
                        : 
                            ''
                        }
                        
                        <div className="line-item__price-list">
                            <span id={wishListItemPrice} className="line-item__price">{currencySymbol}{price}</span>
                        </div>
                        <div>
                            <span id={wishListItemStatus} className="line-item__status">{listItemStatus.label}</span>
                        </div>
                        <div className="line-item__quantity hidden-tablet-and-up">
                            <div className="quantity-selector">
                                <button type="button" className="quantity-selector__button" title={decreaseQuantityLabel} onClick={e => decreaseQty(id, inputQtyMobile, packQty, minQty)}>
                                    <svg focusable="false" className="icon icon--minus" viewBox="0 0 10 2" role="presentation">
                                        <path d="M10 0v2H0V0z" fill="currentColor"></path>
                                    </svg>
                                </button>
                                <input id={inputQtyMobile} aria-label={quantityLabel} className="quantity-selector__value" inputMode="numeric" size="2" onBlur={e => updateQty(id, e.target.value, packQty, minQty)} />
                                <button type="button" className="quantity-selector__button" title={increaseQuantityLabel} onClick={() => increaseQty(id, inputQtyDesktop, packQty, minQty)}>
                                    <svg focusable="false" className="icon icon--plus" viewBox="0 0 10 10" role="presentation">
                                        <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fillRule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                            <a className="line-item__quantity-remove link" onClick={() => removeWishListItem(id)}>{removeLabel}</a>
                        </div>
                        <div id={moveWishListItemToCartAction} className="line-item__quantity hidden-tablet-and-up">
                            <a className="line-item__move_to_cart link" onClick={() => moveWishListItemToCart(id)}>{moveToCartLabel}</a>
                        </div>
                    </div>
                </div>
            </td>
            
            <td className="line-item__quantity table__cell--center hidden-phone">
                <div className="quantity-selector">
                    <button type="button" className="quantity-selector__button" title={decreaseQuantityLabel} onClick={e => decreaseQty(id, inputQtyDesktop, packQty, minQty)}>
                        <svg focusable="false" className="icon icon--minus" viewBox="0 0 10 2" role="presentation">
                            <path d="M10 0v2H0V0z" fill="currentColor"></path>
                        </svg>
                    </button>
                    <input id={inputQtyDesktop} aria-label={quantityLabel} className="quantity-selector__value" inputMode="numeric" size="2" onBlur={e => updateQty(id, e.target.value, packQty, minQty)} />
                    <button type="button" className="quantity-selector__button" title={increaseQuantityLabel} onClick={() => increaseQty(id, inputQtyDesktop, packQty, minQty)}>
                        <svg focusable="false" className="icon icon--plus" viewBox="0 0 10 10" role="presentation">
                            <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fillRule="evenodd"></path>
                        </svg>
                    </button>
                </div>
                <a className="line-item__quantity-remove link" onClick={() => removeWishListItem(id)}>{removeLabel}</a>
            </td>

            <td className="line-item__line-price table__cell--right hidden-phone">
                <span id={wishListItemTotal}>{currencySymbol}{total}</span>
            </td>
        </tr>
        )
    }

    function getPrice(item) {
        return item.product.specialPrice 
            ? 
            parseFloat(item.product.specialPrice ).toFixed(2)
            :
            parseFloat(item.variant.price).toFixed(2);
    }

    function getListItemStatus(item) {
        if (item != undefined && item != null && item.product != undefined && item.product != null && item.product.tags != undefined && item.product.tags != null) {
            const tags = item.product.tags.split(',').map(item => item.trim());

            if (tags.includes('EP:WebSalesChannelFlag|true')) {
                const discontinueCode = tags.find(item => item.startsWith('EP:DiscontinueCode|'));

                if (discontinueCode) {
                    const value = getValueFromTag(discontinueCode, '|');
                    
                    if (value == null || value == '') {
                        return {
                            enabled: true,
                            label: ''
                        }
                    }
                    else {
                        return {
                            enabled: false,
                            label: discontinuedLabel
                        }
                    }
                }
            }
            else {
                return {
                    enabled: false,
                    label: notAvailableLabel
                }
            }

            // if (customerTags.includes("UserType:STPStudent") && tags.includes('EP:StudentCanBuy|N')) {
            //     return {
            //         enabled: false,
            //         label: notAvailableLabel
            //     }
            // }
        }
        
        return {
            enabled: true,
            label: ''
        }
    }

    function getErrorBlock() {
        return (
            <div className="product-form__status-message" style={{height: 'auto'}}>
                <p className="alert alert--error">
                    {`${errorMessage.message} (code: ${errorMessage.errorCode})`}
                </p>
            </div>
        )
    }

    function decreaseQty(id, ctrl, packQty, minQty) {
        const qty = parseInt(document.getElementById(ctrl).value);
        updateQty(id, qty - packQty, packQty, minQty);
    }

    function increaseQty(id, ctrl, packQty, minQty) {
        const qty = parseInt(document.getElementById(ctrl).value);
        updateQty(id, qty + packQty, packQty, minQty);
    }

    function updateQty(id, qty, packQty, minQty) {
        if (qty < minQty) {
            qty = minQty;
        }
        else if (qty > wishListQtyMax) {
            qty = wishListQtyMax;
        }

        qty = qty - (qty % packQty);
        
        updateWishListItemQty(id, qty), [];
    }

    async function updateWishListItemQty (wishListItemId, qty) {
        if (wishListLoading) {
            return;
        }

        const url = `${endpointLink}/updateWishListItemQty`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': token
                },
                body: JSON.stringify({ wishListItemId: wishListItemId, qty: qty })
            });

            const data = await response.json();
            
            if (!data.result) {
                setErrorMessage({ message: data.message, errorCode: data.errorCode });
                console.log(data);
            }
            else {
                const wishListItem = data.data;

                if (wishListItem != undefined && wishListItem) {
                    updateWishListItemQtyUI(wishListItem);
                }
            }
        } catch (error) {
            setErrorMessage({ message: error, errorCode: errorCode.appApiError });
            console.log(error);
        }
    }

    function updateWishListItemQtyUI(wishListItem) {
        const wishListItemId = wishListItem.wishListItemId;

        const index = items.findIndex(itm => wishListItemId);
        items[index].qty = wishListItem.qty;
        
        const inputWishListItemQtyDesktop = document.getElementById(`inputWishListItemQtyDesktop-${wishListItemId}`);
        inputWishListItemQtyDesktop.value = wishListItem.qty;

        const inputWishListItemQtyMobile = document.getElementById(`inputWishListItemQtyMobile-${wishListItemId}`);
        inputWishListItemQtyMobile.value = wishListItem.qty;

        let price = 0;
        const wishListItemPrice = document.getElementById(`wishListItemPrice-${wishListItemId}`).textContent;

        if (wishListItemPrice.startsWith(currencySymbol)) {
            price = parseFloat(wishListItemPrice.replace(currencySymbol, ''))
        }
        
        const total = price * wishListItem.qty;
        
        const wishListItemTotal = document.getElementById(`wishListItemTotal-${wishListItemId}`);
        wishListItemTotal.innerHTML = `${currencySymbol}${total}`;
    }

    async function removeWishListItem(wishListItemId) {
        const url = `${endpointLink}/removeWishListItem`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': token
                },
                body: JSON.stringify({ customerId: customerId, wishListItemId: wishListItemId })
            });

            const data = await response.json();
            
            if (!data.result) {
                setErrorMessage({ message: data.message, errorCode: data.errorCode });
                console.log(data);
            }
            else {
                setItems(items.filter(itm => itm.id != wishListItemId));
                updateStatusOnLoading(false);
            }
        } catch (error) {
            setErrorMessage({ message: error, errorCode: errorCode.appApiError });
            console.log(error);
        }
    }

    async function addItemToCart(wishListItem) {
        const {variantId, qty, product, variant} = wishListItem;
        const specialPrice = product ? product.specialPrice : 0;
        const sku = variant ? variant.sku : '';

        const url = "/cart/add.json";

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    form_type: 'product',
                    id: variantId,
                    properties: {
                        SKU: sku,
                        _stp_price: specialPrice,
                        _amount_spent: `${amount_spent}`,
                        _discount_limit: stp_discount_limit
                    },
                    quantity: qty,
                    utf8: '✓'
                })
            });
            
            const data = await response.json();
            return data;
        } catch (error) {
            setErrorMessage({ message: error, errorCode: errorCode.shopifyApiError });
            console.log(error);
        }
    }

    function setBulkActions(checked) {
        let chk = document.getElementById("checkboxWishListItemAction");
        chk.indeterminate = false;

        const arr = [];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const listItemStatus = getListItemStatus(item);

            if (listItemStatus.enabled) {
                chk = document.getElementById(`checkboxWishListItemAction-${item.id}`);
                chk.checked = checked;
    
                if (checked) {
                    arr.push(item.id);
                } 
            }
        }

        setSelectedItems(arr);
    }

    function setBulkActionControls(id, checked) {
        if (checked) {
            const arr = [...selectedItems];
            arr.push(id);
            setSelectedItems(arr);
        } else {
            const arr = selectedItems.filter(itm => itm != id);
            setSelectedItems(arr);
        }
    }

    async function moveWishListItemToCart(id) {
        moveWishListItemsToCart([id]);
    }

    async function moveWishListItemsToCart(list) {
        let arr = [];
        
        if (list == undefined || list == null || list.length == 0) {
            if (selectedItems.length > 0) {
                arr = [...selectedItems];
            }
        }
        else {
            arr = [...list];
        }
        
        const wishListItemIds = [];

        for (let i = 0; i < arr.length; i++) {
            const id = arr[i];
            const found = items.filter(itm => itm.id === id);

            if (found.length > 0) {
                const wishListItem = found[0];
                
                const cartItem = await addItemToCart(wishListItem);
                
                if (cartItem) {
                    wishListItemIds.push(wishListItem.id);
                }
            }
        }

        if (wishListItemIds.length > 0) {
            removeWishListItems(wishListItemIds);
        }
    }

    async function removeWishListItems(wishListItemIds) {
        const url = `${endpointLink}/removeWishListItems`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': token
                },
                body: JSON.stringify({ customerId: customerId, wishListItemIds: wishListItemIds })
            });

            const data = await response.json();
            
            if (!data.result) {
                setErrorMessage({ message: data.message, errorCode: data.errorCode });
                console.log(data);
            }
            else {
                setItems(items.filter(itm => !wishListItemIds.includes(itm.id)));
                location.reload();
            }
        } catch (error) {
            setErrorMessage({ message: error, errorCode: errorCode.appApiError });
            console.log(error);
        }
    }

    function getValueFromTag(tag, delimiter) {
        if (!tag) {
            return null;
        }

        const tagArr = tag.split(delimiter);
        
        if (tagArr[1]) {
            return tagArr[1].trim();
        }

        return null;
    }

    function getAmountFromTag(tag, delimiter) {
        let val = getValueFromTag(tag, delimiter);

        if (val != null) {
            val = parseFloat(getValueFromTag(tag, delimiter)).toFixed(2);
        }

        return val;
    }
}